import { createRoot } from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import theme from "./app/theme";
import App from "./App";
import "./i18n"; // 👈 initialize translations
import { RecordingProvider } from "./context/RecordingContext";
import { EventProvider } from "./context/EventContext";
import { AuthProvider } from "./context/AuthContext";

const container = document.getElementById("root")!;
createRoot(container).render(
  <ChakraProvider theme={theme}>
    <BrowserRouter>
      <AuthProvider>
        <RecordingProvider>
          <EventProvider>
            <App />
          </EventProvider>
        </RecordingProvider>
      </AuthProvider>
    </BrowserRouter>
  </ChakraProvider>,
);
